'use client';

import cx from 'classnames';
import Link from 'next/link';
import type React from 'react';
import { type ModalT, useApp } from '@/forApp/states/appState/appState';
import styles from './styles.module.css';

type BaseLinkProps = {
  text: string;
  href: string;
  color?: 'white' | 'black';
  type?: 'default' | 'header';
  modal?: ModalT;
};

const BaseLinkOpenModal: React.FC<BaseLinkProps> = ({
  text,
  href,
  color = 'black',
  type = 'default',
  modal,
}) => {
  const { addModal } = useApp();

  const onClickLink = () => {
    if (modal) addModal(modal);
  };
  return (
    <Link
      href={href}
      className={cx(styles.link, styles[color], styles[type])}
      onClick={(evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        onClickLink();
      }}
    >
      {text}
    </Link>
  );
};

export default BaseLinkOpenModal;
